<ejs-dialog #dialog
  [isModal]="true"
  [ngClass]="{'hide-footer': !modalDialog?.showFooter}"
  cssClass="modal-sm"
  [showCloseIcon]="true"
  [visible]="false"
  (close)="onClose($event)">
  <ng-template #header>
    {{$safeNavigationMigration(modalDialog?.title) | translate}}
  </ng-template>

  <ng-template #content>
    {{$safeNavigationMigration(modalDialog?.message) | translate}}
  </ng-template>

  <ng-template #footerTemplate>
    @if (modalDialog?.showFooter) {
      <button class="btn btn-outline-secondary me-2" (click)="cancelClicked()">{{'i18n.shared.cancel' | translate}}</button>
      <button class="btn btn-danger" (click)="okClicked()">{{'i18n.shared.ok' | translate}}</button>
    }
  </ng-template>
</ejs-dialog>
